import axios from "./axios";

class PickRepository {
  getFreePicks() {
    return axios
      .get(`/picks`)
      .then((response) => {
        return response.data;
      })
      .catch((error) => console.log(error));
  }

  createPick(pick) {
    return axios.post(`/picks`, pick).then((response) => {
      return response.data;
    });
  }

  updatePick(pick) {
    return axios.put(`/picks/${pick.id}`, pick).then((response) => {
      return response.data;
    });
  }

  save(pick) {
    if (!pick.id) return this.createPick(pick);
    else return this.updatePick(pick);
  }

  getPick(id) {
    return axios.get(`/picks/${id}`).then((response) => {
      return response.data;
    });
  }

  getAll() {
    return axios.get(`/picks?all=true`).then((response) => {
      return response.data;
    });
  }

  getPremium() {
    return axios.get(`/premium`).then((response) => {
      return response.data;
    });
  }

  remove(pick) {
    return axios.delete(`/picks/${pick.id}`);
  }
}

export default new PickRepository();



// WEBPACK FOOTER //
// ./src/data/pick.repository.js